import React from "react";
import classNames from "classnames";
import { useDownloadDocumentContent } from "@planzone/view-models";
import { DocumentIcon } from "@common/documentIcon";
import { CheckboxInput } from "@common/checkboxInput";
import { useSelectDocumentsContext } from "../../context";
import { Props } from "./types";
import { OpenIcon } from "./openIcon";
import { DownloadIcon } from "./downloadIcon";
import styles from "./styles.scss";

function DocumentCard({ document, openPreview }: Props) {
  const { selection, addToSelection, removeFromSelection } =
    useSelectDocumentsContext();
  const { isRequestPending, downloadDocumentContent } =
    useDownloadDocumentContent(document);
  const isSelected = React.useMemo(
    () => selection.findIndex((doc) => doc.uuid === document.uuid) > -1,
    [selection],
  );
  const selectDocument = () =>
    !isSelected ? addToSelection(document) : removeFromSelection(document.uuid);

  return (
    <div
      className={classNames(styles.documentCard, {
        [styles.isSelected]: isSelected,
      })}
    >
      {isSelected && (
        <CheckboxInput
          className={styles.checkbox}
          isChecked={isSelected}
          onChange={selectDocument}
        />
      )}
      <div className={styles.actions}>
        <div
          className={styles.actionIconBox}
          onClick={() => openPreview(document)}
        >
          <OpenIcon className={styles.actionIcon} />
        </div>
        <div
          className={styles.actionIconBox}
          onClick={() =>
            !isRequestPending &&
            downloadDocumentContent({ document, saveToDisk: true })
          }
        >
          <DownloadIcon className={styles.actionIcon} />
        </div>
      </div>
      <div className={styles.top}>
        <DocumentIcon
          mimeType={document.mimeType}
          className={styles.documentIcon}
        />
      </div>
      <div className={styles.bottom}>
        <DocumentIcon
          mimeType={document.mimeType}
          className={styles.documentIcon}
        />
        <div className={styles.documentInfo}>
          <p>{document.name}</p>
          <span>{new Date(document.createdDate).toLocaleDateString()}</span>
        </div>
      </div>
      <CheckboxInput
        className={styles.checkbox}
        isChecked={isSelected}
        onChange={selectDocument}
      />
      <div className={styles.hoverContainer}>
        <button
          className={styles.lensButton}
          onClick={() => openPreview(document)}
        >
          <svg
            stroke="white"
            fill="white"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="60px"
            width="60px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M456.69 421.39 362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3zM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8 124.95 124.95 0 0 1-124.8-124.8z" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export { DocumentCard };
